function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-12.597 101)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(12.597 -101)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.057,19c-1.536,0-2.794-1.571-3.905-2.957C9.145,14.786,8.2,13.6,7.137,13.6c-1.232,0-2.437,1.022-3.8,3.22l-.683,1.105L1.6,15.083l.683-1.1C3.934,11.3,5.523,10,7.137,10c1.536,0,2.794,1.571,3.905,2.957C12.049,14.214,13,15.4,14.057,15.4c1.232,0,2.437-1.022,3.8-3.22l.683-1.105L19.6,13.917l-.683,1.1C17.237,17.736,15.694,19,14.057,19",
  transform: "translate(-1.597 -10)"
})));

var SvgTilde = function SvgTilde(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 9,
    viewBox: "0 0 18 9",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTilde, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tilde.eae56675.svg";
export { ForwardRef as ReactComponent };